<main
    #pageRoot
    class="rayalina-page ray-page-enter"
    [class.ray-page-enter--ready]="pageEntered"
>
    <section id="home" class="hero" aria-labelledby="hero-title">
        <div class="container hero__grid">
            <div class="hero__copy ray-hero-enter">
                <p class="ray-eyebrow">Commerce à Madagascar</p>
                <h1 id="hero-title" class="text-balance hero__title">
                    Commandes, factures et paiements au même endroit que vos clients.
                </h1>
                <p class="hero__lead">
                    Rayalina remplace les fichiers éparpillés et les fils de discussion sans historique.
                    Vous voyez ce qui est vendu, facturé, encaissé ou encore dû.
                </p>
                <div class="hero__actions">
                    <button type="button" class="primary-btn" (click)="startCheckout('trial')">
                        Démarrer l'essai gratuit
                    </button>
                    <a href="#pricing" class="secondary-btn">Voir les tarifs</a>
                </div>
                <ul class="hero__checklist" aria-label="Inclus dès l'essai">
                    <li><i class="bx bx-check" aria-hidden="true"></i> Commandes et factures</li>
                    <li><i class="bx bx-check" aria-hidden="true"></i> Suivi des clients et paiements</li>
                    <li><i class="bx bx-check" aria-hidden="true"></i> Inventaire et tableau de bord</li>
                </ul>
            </div>
            <figure class="hero__media ray-hero-enter__media product-shot product-shot--hero">
                <div class="product-shot__chrome" aria-hidden="true">
                    <span class="product-shot__dots">
                        <span></span><span></span><span></span>
                    </span>
                    <span class="product-shot__url">app.rayalina.com</span>
                </div>
                <div class="product-shot__viewport">
                    <img
                        src="assets/img/screenshots/hero-dashboard.png"
                        width="1120"
                        height="700"
                        [alt]="heroScreenshot.alt"
                        loading="eager"
                        decoding="async"
                    />
                </div>
                <figcaption class="product-shot__caption">
                    {{ heroScreenshot.label }} · aperçu produit
                </figcaption>
            </figure>
        </div>
    </section>

    <section id="problems" class="ray-section pain-section" aria-labelledby="pain-title">
        <div class="container pain-section__shell">
            <div class="pain-section__layout">
                <header class="pain-section__intro" data-ray-reveal>
                    <span class="pain-section__eyebrow">Le problème</span>
                    <h2 id="pain-title" class="pain-section__title text-balance">
                        Quand tout vit dans
                        <span class="pain-section__title-accent">des messages et des fichiers</span>,
                        la boutique ralentit.
                    </h2>
                    <p class="pain-section__lede">
                        Pas besoin d'un ERP lourd : il faut un lien simple mais efficace entre vente, facturation, encaissement
                        et, plus tard, stock.
                    </p>
                </header>
                <ol class="pain-grid ray-reveal-group" data-ray-reveal>
                    <li
                        class="pain-grid__cell"
                        *ngFor="let pain of pains; let i = index"
                        [style.--reveal-i]="i"
                    >
                        <span class="pain-grid__ghost" aria-hidden="true">{{ pain.index }}</span>
                        <div class="pain-grid__content">
                            <span class="pain-grid__index" aria-hidden="true">{{ pain.index }}</span>
                            <h3>{{ pain.title }}</h3>
                            <p>{{ pain.text }}</p>
                        </div>
                    </li>
                </ol>
            </div>
        </div>
    </section>

    <section id="solution" class="ray-section solution-section">
        <div class="container solution__grid">
            <div class="solution__visuals" data-ray-reveal>
                <figure
                    class="solution__shot product-shot product-shot--feature"
                    *ngFor="let shot of solutionScreenshots; let i = index"
                    [class.solution__shot--secondary]="i === 1"
                >
                    <div class="product-shot__chrome" aria-hidden="true">
                        <span class="product-shot__dots">
                            <span></span><span></span><span></span>
                        </span>
                        <span class="product-shot__url">app.rayalina.com</span>
                    </div>
                    <div class="product-shot__viewport">
                        <img
                            [src]="productShotSrc(shot.seed, 1120, 630)"
                            width="1120"
                            height="630"
                            [alt]="shot.alt"
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                    <figcaption class="product-shot__caption">
                        {{ shot.label }} · aperçu produit
                    </figcaption>
                </figure>
            </div>
            <div class="solution__copy">
                <header class="ray-section-head" data-ray-reveal>
                    <span class="ray-eyebrow">La solution</span>
                    <h2 class="text-balance">Un même espace pour vendre, facturer et suivre.</h2>
                    <p>
                        Dès l'essai : commandes, factures, paiements, clients et tableau de bord.
                        Puis achats, fournisseurs, stocks et utilisateurs quand votre volume le demande.
                    </p>
                </header>
                <ol class="solution-ladder ray-reveal-group" role="list" data-ray-reveal>
                    <li
                        class="solution-ladder__step"
                        *ngFor="let cap of solutionCapabilities; let i = index"
                        [style.--reveal-i]="i"
                    >
                        <span class="solution-ladder__marker" aria-hidden="true">
                            <span class="solution-ladder__index">{{ cap.index }}</span>
                        </span>
                        <div class="solution-ladder__body">
                            <span class="solution-ladder__tier">{{ cap.tier }}</span>
                            <h3 class="solution-ladder__title">{{ cap.title }}</h3>
                            <p class="solution-ladder__detail">{{ cap.detail }}</p>
                        </div>
                    </li>
                </ol>
            </div>
        </div>
    </section>

    <section id="features" class="ray-section features-section">
        <div class="container">
            <header class="ray-section-head ray-section-head--center" data-ray-reveal>
                <span class="ray-eyebrow">Fonctionnalités</span>
                <h2 class="text-balance">Trois blocs, de l'essai à la structure complète.</h2>
                <p>
                    Commandes, factures, paiements et clients dès le départ ; pilotage et exports ensuite ;
                    stocks et équipe quand votre rythme l'exige, sans changer d'outil.
                </p>
            </header>
            <div class="features-bento">
                <article class="features-bento__lead" aria-labelledby="feature-lead-title" data-ray-reveal>
                    <figure class="features-bento__visual product-shot product-shot--feature">
                        <div class="product-shot__chrome" aria-hidden="true">
                            <span class="product-shot__dots">
                                <span></span><span></span><span></span>
                            </span>
                            <span class="product-shot__url">app.rayalina.com</span>
                        </div>
                        <div class="product-shot__viewport">
                            <img
                                [src]="productShotSrc(featureLead.seed)"
                                width="1120"
                                height="640"
                                [alt]="featureLead.alt"
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                        <figcaption class="product-shot__caption">
                            {{ featureLead.label }} · aperçu produit
                        </figcaption>
                    </figure>
                    <div
                        class="features-bento__card"
                        [class.features-bento__card--featured]="featureLead.featured"
                    >
                        <header class="features-bento__head">
                            <span class="features-bento__label">{{ featureLead.label }}</span>
                            <span class="features-bento__badge">{{ featureLead.tier }}</span>
                        </header>
                        <span class="features-bento__icon" aria-hidden="true">
                            <i class="bx" [ngClass]="featureLead.icon"></i>
                        </span>
                        <h3 id="feature-lead-title" class="features-bento__title">{{ featureLead.title }}</h3>
                        <p class="features-bento__lede">{{ featureLead.lede }}</p>
                        <ul class="features-bento__features">
                            <li *ngFor="let point of featureLead.points">
                                <i class="bx bx-check" aria-hidden="true"></i>{{ point }}
                            </li>
                        </ul>
                    </div>
                </article>
                <div class="features-bento__row ray-reveal-group" data-ray-reveal>
                    <article
                        class="features-bento__card"
                        *ngFor="let group of featureMore; let i = index"
                        [class.features-bento__card--featured]="group.featured"
                        [attr.aria-labelledby]="'feature-card-' + i"
                        [style.--reveal-i]="i"
                    >
                        <header class="features-bento__head">
                            <span class="features-bento__label">{{ group.label }}</span>
                            <span class="features-bento__badge">{{ group.tier }}</span>
                        </header>
                        <span class="features-bento__icon" aria-hidden="true">
                            <i class="bx" [ngClass]="group.icon"></i>
                        </span>
                        <h3 [id]="'feature-card-' + i" class="features-bento__title">{{ group.title }}</h3>
                        <p class="features-bento__lede">{{ group.lede }}</p>
                        <ul class="features-bento__features">
                            <li *ngFor="let point of group.points">
                                <i class="bx bx-check" aria-hidden="true"></i>{{ point }}
                            </li>
                        </ul>
                    </article>
                </div>
            </div>
        </div>
    </section>

    <section id="how-it-works" class="ray-section steps-section">
        <div class="container">
            <header class="ray-section-head ray-section-head--center" data-ray-reveal>
                <span class="ray-eyebrow">Comment ça marche</span>
                <h2 class="text-balance">Trois étapes, sans changement d'outil.</h2>
            </header>
            <ol class="steps-track ray-reveal-group" data-ray-reveal>
                <li
                    class="steps-track__step"
                    *ngFor="let step of steps; let i = index"
                    [style.--reveal-i]="i"
                >
                    <figure class="steps-track__visual product-shot product-shot--step">
                        <div class="product-shot__viewport">
                            <img
                                [src]="productShotSrc(step.seed, 640, 400)"
                                width="640"
                                height="400"
                                [alt]="step.alt"
                                loading="lazy"
                                decoding="async"
                            />
                        </div>
                        <figcaption class="product-shot__caption">{{ step.label }}</figcaption>
                    </figure>
                    <div class="steps-track__body">
                        <span class="steps-track__num" aria-hidden="true">{{ i + 1 }}</span>
                        <div>
                            <h3>{{ step.title }}</h3>
                            <p>{{ step.text }}</p>
                        </div>
                    </div>
                </li>
            </ol>
        </div>
    </section>

    <section id="pricing" class="ray-section pricing-section">
        <div class="container">
            <header class="ray-section-head ray-section-head--center" data-ray-reveal>
                <span class="ray-eyebrow">Tarifs</span>
                <h2 class="text-balance">Des formules qui suivent votre volume.</h2>
            </header>
            <div
                class="pricing-billing-toggle-wrap"
                *ngIf="!pricingLoading && pricingPlans.length && showBillingPeriodToggle"
                role="group"
                aria-label="Fréquence de facturation"
                data-ray-reveal
            >
                <div
                    class="pricing-billing-toggle"
                    [class.pricing-billing-toggle--yearly]="billingPeriod === 'yearly'"
                >
                    <button
                        type="button"
                        class="pricing-billing-option"
                        [class.active]="billingPeriod === 'monthly'"
                        (click)="setBillingPeriod('monthly')"
                    >
                        Mensuel
                    </button>
                    <button
                        type="button"
                        class="pricing-billing-option"
                        [class.active]="billingPeriod === 'yearly'"
                        (click)="setBillingPeriod('yearly')"
                    >
                        Annuel
                        <span class="pricing-billing-save">−20&nbsp;%</span>
                    </button>
                </div>
                <p class="pricing-billing-hint" *ngIf="billingPeriod === 'yearly'">
                    Paiement annuel : 12 mois avec 20&nbsp;% de réduction par rapport au mensuel cumulé.
                </p>
            </div>
            <div
                class="pricing-grid ray-reveal-group"
                *ngIf="!pricingLoading && pricingPlans.length"
                data-ray-reveal
            >
                <article
                    class="pricing-plan"
                    *ngFor="let row of pricingRows; let i = index"
                    [class.pricing-plan--featured]="row.plan.featured"
                    [class.pricing-plan--annual]="billingPeriod === 'yearly'"
                    [style.--reveal-i]="i"
                >
                    <header class="pricing-plan__head">
                        <span class="pricing-plan__name">{{ row.plan.name }}</span>
                        <span class="pricing-plan__badge" *ngIf="row.plan.badge">{{ row.plan.badge }}</span>
                    </header>
                    <div class="pricing-plan__price-block">
                        <h3
                            class="pricing-plan__price"
                            [class.pricing-plan__price--stacked]="!!pp.yearlySubtitle"
                            *ngIf="row.priceParts as pp; else pricePlain"
                        >
                            <span class="pricing-plan__price-main">
                                <span class="pricing-plan__price-value">{{
                                    pp.headlineAmountMga | currency : "MGA" : "symbol-narrow" : "1.0-0" : "fr-FR"
                                }}</span
                                ><span class="pricing-plan__price-suffix">{{ pp.suffix }}</span>
                            </span>
                            @if (pp.yearlySubtitle; as sub) {
                                <span class="pricing-plan__price-tail">
                                    soit
                                    {{ sub.totalYearMga | currency : "MGA" : "symbol-narrow" : "1.0-0" : "fr-FR" }}
                                    /an, payés en une fois. Économie
                                    {{ sub.savingsMga | currency : "MGA" : "symbol-narrow" : "1.0-0" : "fr-FR" }}
                                </span>
                            }
                        </h3>
                        <ng-template #pricePlain>
                            <h3 class="pricing-plan__price pricing-plan__price--plain">{{ row.plainLabel }}</h3>
                        </ng-template>
                        <p class="pricing-plan__note" *ngIf="billingPeriod === 'yearly' && !row.hasYearlySavingsSubtitle">
                            Offre limitée sur la facturation annuelle.
                        </p>
                    </div>
                    <p class="pricing-plan__desc">{{ row.plan.description }}</p>
                    <div class="pricing-plan__cta">
                        <a
                            *ngIf="row.plan.ctaHref"
                            [href]="row.plan.ctaHref"
                            [class.primary-btn]="row.plan.featured"
                            [class.secondary-btn]="!row.plan.featured"
                        >
                            {{ row.plan.ctaLabel }}
                        </a>
                        <button
                            *ngIf="row.plan.planId && !row.plan.ctaHref"
                            type="button"
                            [class.primary-btn]="row.plan.featured"
                            [class.secondary-btn]="!row.plan.featured"
                            (click)="startCheckout(row.plan.planId!)"
                        >
                            {{ row.plan.ctaLabel }}
                        </button>
                    </div>
                    <ul class="pricing-plan__features">
                        <li *ngFor="let item of row.plan.items">
                            <i class="bx bx-check" aria-hidden="true"></i>{{ item }}
                        </li>
                    </ul>
                </article>
            </div>
            <p *ngIf="pricingLoading" class="pricing-status">Chargement des offres…</p>
            <p *ngIf="!pricingLoading && !pricingPlans.length" class="pricing-status">
                Les offres ne sont pas disponibles pour le moment. Réessayez plus tard.
            </p>
        </div>
    </section>

    <section id="contact" class="ray-section cta-band" aria-labelledby="cta-band-title">
        <div class="container cta-band__shell">
            <div class="cta-band__panel" data-ray-reveal>
                <div class="cta-band__copy">
                    <span class="cta-band__eyebrow">Essai gratuit</span>
                    <h2 id="cta-band-title" class="text-balance cta-band__title">
                        Prêt à structurer
                        <span class="cta-band__title-accent">ventes, factures et encaissements</span>
                        ?
                    </h2>
                    <p class="cta-band__lede">
                        Commencez sans friction. Ajoutez stocks, fournisseurs et équipe quand votre rythme l'exige.
                    </p>
                    <ul class="cta-band__proof" aria-label="Inclus dès l'essai">
                        <li><i class="bx bx-check" aria-hidden="true"></i> Commandes et factures</li>
                        <li><i class="bx bx-check" aria-hidden="true"></i> Paiements en Ariary</li>
                        <li><i class="bx bx-check" aria-hidden="true"></i> Sans carte bancaire</li>
                    </ul>
                </div>
                <div class="cta-band__action">
                    <button type="button" class="primary-btn cta-band__btn" (click)="startCheckout('trial')">
                        Démarrer l'essai gratuit
                    </button>
                    <p class="cta-band__note">Mobile Money accepté · Garantie 30 jours</p>
                </div>
            </div>
        </div>
    </section>
</main>
